@if (compact) {
  <div class="flex items-center justify-end gap-2 w-full pt-2 text-xs font-normal not-italic">
    <span class="text-xs text-stone-500 font-medium select-none mr-1 not-italic">
      {{ pageLabel }} <span class="font-bold text-primary not-italic">{{ currentPage }}</span> {{ ofLabel }} <span class="font-bold text-primary not-italic">{{ totalPages || 1 }}</span>
    </span>

    @if (totalPages > 1) {
      <button
        type="button"
        (click)="prevPage()"
        [disabled]="firstPage === true || currentPage <= 1"
        class="inline-flex items-center justify-center w-7 h-7 text-stone-600 hover:text-primary hover:bg-surface active:bg-primary-100 disabled:opacity-30 disabled:pointer-events-none rounded-lg border-[1px] border-solid border-stone-200 bg-surface-card transition-colors cursor-pointer"
        [title]="previousLabel"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button
        type="button"
        (click)="nextPage()"
        [disabled]="lastPage === true || currentPage >= totalPages"
        class="inline-flex items-center justify-center w-7 h-7 text-stone-600 hover:text-primary hover:bg-surface active:bg-primary-100 disabled:opacity-30 disabled:pointer-events-none rounded-lg border-[1px] border-solid border-stone-200 bg-surface-card transition-colors cursor-pointer"
        [title]="nextLabel"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    }
  </div>
} @else {
  @if (totalPages > 0) {
    <nav class="flex items-center justify-between py-3 rounded-b-2xl font-normal not-italic" aria-label="Pagination">
      <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        @if (showPageInfo) {
          <div>
            <p class="text-sm text-stone-500 font-normal not-italic">
              {{ pageLabel }} <span class="font-semibold text-primary not-italic">{{ currentPage }}</span> {{ ofLabel }} <span class="font-semibold text-primary not-italic">{{ totalPages || 1 }}</span>
            </p>
          </div>
        } @else {
          <div></div>
        }

        @if (totalPages > 1) {
          <div>
            <div class="inline-flex items-center gap-1">
              <!-- Previous Button -->
              <button
                type="button"
                (click)="prevPage()"
                [disabled]="firstPage === true || currentPage <= 1"
                class="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-stone-600 bg-surface-card border-[1px] border-solid border-stone-200 rounded-lg hover:bg-surface hover:text-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
              >
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                <span>{{ previousLabel }}</span>
              </button>

              <!-- Pages -->
              <div class="flex items-center gap-1 mx-1">
                @for (page of visiblePages; track $index) {
                  @if (page === '...') {
                    <span class="inline-flex items-center justify-center w-8 h-8 text-xs font-medium text-stone-400">...</span>
                  } @else {
                    <button
                      type="button"
                      (click)="goToPage(page)"
                      [class.bg-primary-800]="currentPage === page"
                      [class.text-white]="currentPage === page"
                      [class.border-primary-800]="currentPage === page"
                      [class.shadow-sm]="currentPage === page"
                      [class.font-bold]="currentPage === page"
                      [class.text-stone-700]="currentPage !== page"
                      [class.bg-surface-card]="currentPage !== page"
                      [class.hover:bg-surface]="currentPage !== page"
                      [class.hover:text-primary]="currentPage !== page"
                      [class.border-stone-200]="currentPage !== page"
                      class="inline-flex items-center justify-center w-8 h-8 text-xs font-semibold border-[1px] border-solid rounded-lg transition-colors cursor-pointer"
                    >
                      {{ page }}
                    </button>
                  }
                }
              </div>

              <!-- Next Button -->
              <button
                type="button"
                (click)="nextPage()"
                [disabled]="lastPage === true || currentPage >= totalPages"
                class="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-stone-600 bg-surface-card border-[1px] border-solid border-stone-200 rounded-lg hover:bg-surface hover:text-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
              >
                <span>{{ nextLabel }}</span>
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        }
      </div>

      <!-- Mobile view -->
      @if (totalPages > 1) {
        <div class="flex items-center justify-between flex-1 sm:hidden">
          <button
            type="button"
            (click)="prevPage()"
            [disabled]="firstPage === true || currentPage <= 1"
            class="px-3 py-1.5 text-xs font-semibold text-stone-600 bg-surface-card border-[1px] border-solid border-stone-200 rounded-lg disabled:opacity-40"
          >
            {{ previousLabel }}
          </button>
          <span class="text-xs text-stone-600">
            {{ currentPage }} / {{ totalPages || 1 }}
          </span>
          <button
            type="button"
            (click)="nextPage()"
            [disabled]="lastPage === true || currentPage >= totalPages"
            class="px-3 py-1.5 text-xs font-semibold text-stone-600 bg-surface-card border-[1px] border-solid border-stone-200 rounded-lg disabled:opacity-40"
          >
            {{ nextLabel }}
          </button>
        </div>
      }
    </nav>
  }
}
